<template>
  <div>
    <b-row>
      <b-col>
        <b-table class="table-sm text-center" responsive outlined hover head-variant="light" :no-local-sorting=true
          :sort-by.sync="filters.sort_field" :sort-desc.sync="filters.sort_order" :fields="tableFields" :items="samples">

          <template v-slot:cell(created_at)="{ value }">{{ momentf(value) }}</template>
          <template v-slot:cell(tags)="row">
            <b-badge v-for="tag in row.item.tags_data" :key="tag.id" class="mx-1">{{ tag.name }}</b-badge>
          </template>
          <template v-slot:cell(detection_uuid)="{value}">{{value}}</template>
          <template v-slot:cell(files)="{ item }">
            <FilesPreviewSlider
              v-if="item.files?.length"
              :files="item.files"
              :set_id="item.sample_set_id"
              image_type="sample"
            />
            <FilesPreviewSlider
              v-else-if="item.detection_files?.length"
              :files="item.detection_files"
              :set_id="item.detection_set_id"
              image_type="detection"
            />
            <span v-else>No files</span>
          </template>
          <template v-slot:cell(options)="row">
            <div class="flex-container options-center">
              <router-link v-if="row.item.actions.update"
              :to="{ name: 'SampleUpdate', params: { project_id: row.item.project_id, sample_set_id: row.item.sample_set_id, id: row.item.id } }">
                <a><i class="mx-1 fa fa-edit fa-lg" /></a>
              </router-link>
              <div>
                <i class="fa fa-trash fa-danger fa-lg" v-if="row.item.actions.delete"
                  @click="$emit('sendForDelete', row.item.id)" />
              </div>
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import FilesPreviewSlider from '@/views/Shared/FilesPreviewSlider.vue';

export default {
  props: {
    tableFields: {
      value: Array,
      required: true
    },
    filters: {
      value: Object,
      required: true
    },
    samples: {
      value: Array,
      required: true
    },
  },
  components: {
    FilesPreviewSlider,
  },
};
</script>
